module.exports = __webpack_public_path__ + "static/media/Input Manufacturer - GBR care Infographic Desktop 05-03-2024 .b2121512.gif";